import React, { Component } from "react";
// import ReactTable from "react-table";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from "./Utils";
import FileChooser from "./FileChooser";
class Hospital extends Component {
  constructor() {
    super();
    this.state = {
      dataStartedProcessing: false,
      onEditClick: false,
      changedLogoWhileUpdate: false,
      showLogo: false,
      hospitalLogo: "",
      hospitalLogoName: "",
      selectedHealthSystemId: "",
      showLoader: false,
      data: [
        {
          id: "",
          name: "",
          description: "",
          address: "",
        },
      ],
      hideTextAreaPopup: false,
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      topHeading: "",
      healthSystemValue: [],
      editedName: "",
      editedDescription: "",
      editedAddress: "",
      editedWebsite: "",
      invalidFileName: false,
      searchTerm: "",
      noMatchingData: false,
      isLoading: true,
      tableReady: false,

    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.state.selectedHealthSystemId = localStorage.getItem("healthSystemId");
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.setState(this.state);
    this.healthSystemDropDownInHospitalRef = React.createRef();
  }

  componentDidMount() {
    var thisController = this;
    const savedPage = localStorage.getItem("lastHospitalActivePage");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastHospitalActivePage");
    } else {
      thisController.restoredPage = 1;
    }

    if (thisController.props.location.state != undefined) {
      thisController.state.pageNum =
        thisController.props.location.state.pageNum;
      thisController.state.selectedHealthSystemId =
        thisController.props.location.state.healthSystemId;
      thisController.setState(thisController.state);
    }
    thisController.fetchHealthSystemDetails();
  }

  addNewHospitalRow = () => {
    var addController = this;
    addController.state.showLogo = false;
    addController.state.hospitalLogo = "";
    addController.state.hospitalLogoName = "";
    addController.state.changedLogoWhileUpdate = false;
    if (addController.state.pageNum != 0) {
      addController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      name: "",
      description: "",
      address: "",
      hospitalLogo: null,
    });
    this.setState({
      noMatchingData: false,
      data: this.state.data,
      disabled: true,
    });
  };
  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }


  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no hospital present. </p>
    </div>
  );

  fetchHospitalDetails() {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
    }
    $.ajax({
      url: "/my-jeeva-api/hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.data = res.result;
          thisController.state.disabled = false;
          thisController.state.showLoader = true;
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false;
          thisController.state.showLogo = true;
          thisController.state.pageNum = thisController.restoredPage || 1;
          thisController.state.tableReady = true;
          thisController.setState(thisController.state);
        } else {
          // thisController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }
  notifySelectHealthSystem() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Health System
      </b>,
      {
        position: "top-center",
      }
    );
  }
  saveHospitalDetails = (row, e) => {
    var thisController = this;

    var userRole = thisController.userDetails["userRole"];
    var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
    var websitePattern = new RegExp(/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/);
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = this.state.selectedHealthSystemId;
    }

    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else {
      row.name = document.getElementById("name" + row.id).innerText.trim();
      row.description = document
        .getElementById("description" + row.id)
        .innerText.trim();
      row.address = document
        .getElementById("address" + row.id)
        .innerText.trim();
      row.website = document
        .getElementById("website" + row.id)
        .innerText.trim();
      if (
        row.name == "" ||
        row.address == "" ||
        row.website == ""
      ) {
        thisController.notifyEmptyFields();
      } else if (!namePattern.test(row.name)) {
        thisController.notifyImproperName();
      } else if (!websitePattern.test(row.website)) {
        thisController.notifyImproperUrl();
      } else if (thisController.state.invalidFileName) {
        thisController.notifyImproperContent();
      } else if (thisController.state.hospitalLogo == "") {
        thisController.notifyEmptyLogoField();
      } else {
        this.state.editedId = "-1";
        this.state.dataStartedProcessing = true;
        this.setState(this.state);
        var formData = new FormData();
        formData.append("name", row.name);
        formData.append("description", row.description);
        formData.append("address", row.address);
        formData.append("healthSystemId", healthSystemId);
        formData.append("website", row.website);
        formData.append("hospitalLogo", thisController.state.hospitalLogo);
        var timer = setInterval(function () {
          clearTimeout(timer);
          $.ajax({
            url: "/my-jeeva-api/hospital",

            method: "POST",
            data: formData,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            processData: false,
            contentType: false,
            success: function (res) {
              if (res.success === true) {
                thisController.state.dataStartedProcessing = false;
                thisController.state.hospitalLogo = "";
                thisController.state.hospitalLogoName = "";
                thisController.setState(thisController.state);
                thisController.notifyAdded();
                thisController.fetchHospitalDetails();
                thisController.setState({ disabled: false });
              } else {
                thisController.notifyFailedResponse(res.result);
              }
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "";
              }
            },
          });
        }, 2000);
      }
    }
  };

  notifyImproperAddress() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid address
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyImproperUrl() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid URL
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyImproperName() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid name
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyImproperContent() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Uploaded file seems to be invalid. Please upload valid Image file.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  handleNameChange = (e, props) => {
    this.state.editedName = e.currentTarget.textContent;
    this.setState(this.state);
  }
  handleDescriptionChange = (e, props) => {
    this.state.editedDescription = e.currentTarget.textContent;
    this.setState(this.state);
  }
  handleAddressChange = (e, props) => {
    this.state.editedAddress = e.currentTarget.textContent;
    this.setState(this.state);
  }
  handleWebsiteChange = (e, props) => {
    this.state.editedWebsite = e.currentTarget.textContent;
    this.setState(this.state);
  }

  updateDetailsApi = (row, e) => {
    var thisController = this;

    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = this.state.selectedHealthSystemId;
    }
    if (healthSystemId == "Select Health System") {
      this.notifySelectHealthSystem();
    } else {
      // var name = document.getElementById("name" + row.id).innerText.trim();
      // var description = document.getElementById("description" + row.id).innerText.trim();
      // var address = document.getElementById("address" + row.id).innerText.trim();
      // var website = document.getElementById("website" + row.id).innerText.trim();

      var name = thisController.state.editedName.trim();
      var description = thisController.state.editedDescription.trim();
      var address = thisController.state.editedAddress.trim();
      var website = thisController.state.editedWebsite.trim();

      console.log(("address is : " + address));

      // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
      var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
      var addressPattern = new RegExp(/^[a-zA-Z0-9 \-.,/#()']+(\s?[a-zA-Z0-9 \-.,/#()']+)*$/);
      // var websitePattern = new RegExp(
      //   /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
      // );

      var websitePattern = new RegExp(/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/);

      var username = name;
      var userDesc = description;
      var userAddress = address;
      var userWebsite = website;

      if (username == "" || userAddress == "" || userWebsite == "") {
        thisController.notifyEmptyFields();
      }
      //  else if (!addressPattern.test(userAddress.replace(/\\/g, ""))) {
      //   thisController.notifyImproperAddress();
      // } 
      if (name == "" || address == "" || website == "") {
        name = row.name;
        address = row.address;
        website = row.website;
      } else if (!namePattern.test(username)) {
        thisController.notifyImproperName();
      } else if (!websitePattern.test(userWebsite)) {
        thisController.notifyImproperUrl();
      } else if (thisController.state.invalidFileName) {
        thisController.notifyImproperContent();
      }
      else {
        var thisController = this;
        thisController.state.dataStartedProcessing = true;
        thisController.setState(thisController.state);

        var formData = new FormData();
        formData.append("id", row.id);
        formData.append("name", name);
        formData.append("description", description);
        formData.append("address", address);
        formData.append("healthSystemId", healthSystemId);
        formData.append("website", website);
        if (this.state.changedLogoWhileUpdate) {
          formData.append("hospitalLogo", thisController.state.hospitalLogo);
        }
        var timer = setInterval(function () {
          clearTimeout(timer);
          $.ajax({
            url: "/my-jeeva-api/hospital",

            method: "PATCH",
            data: formData,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            processData: false,
            contentType: false,
            success: function (res) {
              if (res.success === true) {
                thisController.state.dataStartedProcessing = false;
                thisController.state.editedId = "-1";
                thisController.state.hospitalLogo = "";
                thisController.state.hospitalLogoName = "";
                thisController.state.changedLogoWhileUpdate = false;
                thisController.state.invalidFileName = false;
                thisController.setState(thisController.state);
                thisController.notifyUpdate();
                thisController.fetchHospitalDetails();
              } else {
                thisController.notifyFailedResponse(res.result);
              }
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "";
              }
            },
          });
        }, 2000);
      }
    }
  };

  deleteDetailApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteApiViewController.setState({ hideDeletePopup: false });
      deleteApiViewController.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-hospital/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteRowViewController.splice(id, 1);
            deleteApiViewController.fetchHospitalDetails();
            deleteApiViewController.refreshData();
          } else {
            // deleteRowViewController.notifyError();
            deleteApiViewController.fetchHospitalDetails();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }

    // if (this.state.deleteRow) {
    //   this.state.data.splice(id, 1);
    // }

  };
  makeCelledit(row, e) {
    this.markAsBeingEdited(row);
    this.state.editedName = row.name;
    this.state.editedDescription = row.description;
    this.state.editedAddress = row.address;
    this.state.editedWebsite = row.website;
    this.state.hospitalLogo = "";
    // Logos uploaded before file names were stored have no name to show
    this.state.hospitalLogoName = row.hospitalLogoFileName || (row.hospitalLogo ? "Current logo" : "");
    this.state.changedLogoWhileUpdate = false;
    this.state.invalidFileName = false;
    this.setState(this.state);
  }

  markAsBeingEdited(row) {
    this.state.editedId = row.id;
    this.state.onEditClick = true;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }



  refreshData = (id) => {
    this.setState({
      editedId: id,
      disabled: false,
      isLoading: true,
      data: [],
      searchTerm: ""
    });
    this.fetchHospitalDetails();
  };

  notifyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Hospital Detail added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Hospital Details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Hospital Detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyLogoField() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Choose Hospital Logo
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastHospitalActivePage", e);

  };

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyDataProcessing() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Hold on.Your data is saving...
      </b>,
      {
        position: "top-center",
      }
    );
  }

  paintHeading = () => {
    var healthSystemName = localStorage.getItem("healthSystemName");
    var hospitalName = localStorage.getItem("hospitalName");
    var serviceLineName = localStorage.getItem("serviceName");

    var heading = "";
    if (healthSystemName) {
      heading = healthSystemName;
      if (hospitalName) {
        heading = hospitalName + " | " + heading;
        if (serviceLineName) {
          heading = serviceLineName + " | " + heading;
        }
      }
    }
    this.state.topHeading = heading;
    this.setState(this.state);
  };

  onHealthSystemChange = (e) => {
    var selectBox = e.target;
    this.state.isLoading = true;
    if (this.state.selectedHealthSystemId != selectBox.value) {
      this.state.hospitalId = null;
      localStorage.setItem(`hospitalName`, null);
      localStorage.setItem("serviceName", null);
    }
    this.state.selectedHealthSystemId = selectBox.value;

    localStorage.setItem("healthSystemId", this.state.selectedHealthSystemId);
    if (selectBox.value != "") {
      localStorage.setItem("healthSystemName", selectBox.options[selectBox.selectedIndex].innerText);
    }
    this.setState(this.state);
    window.adminNavigationBar.paintHeading();
    this.fetchHospitalDetails();
  };

  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          if (!thisController.state.selectedHealthSystemId) {
            var healthSystemsDropDownList =
              thisController.healthSystemDropDownInHospitalRef.current;
            if (healthSystemsDropDownList) {
              thisController.state.selectedHealthSystemId =
                healthSystemsDropDownList.value;
              // setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInHospitalRef.current }) }, 100);
            } else {
              thisController.state.selectedHealthSystemId = res.result[0].id;
              // setTimeout(() => { thisController.onHealthSystemChange({ target: thisController.healthSystemDropDownInHospitalRef.current }) }, 100);
            }
          }
          thisController.setState(thisController.state);
          setTimeout(() => {
            var selectBox = thisController.healthSystemDropDownInHospitalRef.current;
            if (selectBox && selectBox.selectedIndex >= 0) {
              console.log("The current Health System is :" + selectBox.options[selectBox.selectedIndex].innerText);
              thisController.onHealthSystemChange({ target: selectBox });
            }
          }, 100);
          thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      }, error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }

  addAdmin = (row, e) => {
    var userRole = this.userDetails["userRole"];
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = this.userDetails["healthSystemId"];
    } else {
      healthSystemId = this.state.selectedHealthSystemId;
    }
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastHospitalActivePage", pageToSave);

    this.props.history.push({
      pathname: "/projectmgmt/hospital-admin",
      state: {
        hospitalId: row.id,
        healthSystemId: healthSystemId,
      },
    });
    this.setState(this.setState);
  };
  handleAnchor = (id, name) => {
    window.adminNavigationBar.markActiveTab();
    var existingHospitalId = localStorage.getItem("hospitalId");
    if (existingHospitalId != id) {
      localStorage.removeItem("serviceLineId");
      localStorage.removeItem("serviceName");
    }
    localStorage.setItem("hospitalId", id);
    localStorage.setItem("hospitalName", name);
  };
  onChangehospitalLogo = (event) => {
    this.state.invalidFileName = false;
    this.setState(this.state);
    if (event.target.files[0] == undefined) {
      console.log("There is no file choosen");
    } else {
      var fileName = event.target.files[0].name;
      this.state.hospitalLogoName = fileName;
      if (fileName) {
        var fileExtension = event.target.files[0].name.split(".").pop().toLowerCase();
        var validExtensions = ["jpg", "jpeg", "png", "gif"];
        console.log("The extension of uploaded file is : " + fileExtension);
        console.log("Is this valid extension ? " + validExtensions.includes(fileExtension));

        if (validExtensions.includes(fileExtension)) {
          this.state.hospitalLogo = event.target.files[0];
          this.state.changedLogoWhileUpdate = true;
          this.setState(this.state);
        } else {
          this.state.invalidFileName = true;
          this.setState(this.state);
        }
      }


    }


  };
  openDeletePopUp = (row) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${row.name} ?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteDetailApi(row.id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field] ? rowA[field].toLowerCase() : '';
    const b = rowB[field] ? rowB[field].toLowerCase() : '';

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.data = [];
    thisController.setState(thisController.state);
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
    }

    $.ajax({
      url: "/my-jeeva-api/search-hospital-data",
      method: "GET",
      data: {
        healthSystemId: healthSystemId,
        searchTerm: thisController.state.searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.data = [];
            thisController.setState(thisController.state);
            thisController.state.data = res.result;
            thisController.state.noMatchingData = false;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.fetchHealthSystemDetails();
    });
}

  render() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}> Name</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('name'),
        selector: (props) => (
          <div name="name">
            <a
              href={
                props.id == "" || props.id == this.state.editedId
                  ? "javascript:void(0)"
                  : window.SCOPE_VALUE.CURRENT == 9
                    ? "/my-jeeva/projectmgmt"
                    : "/my-jeeva/projectmgmt/service-line"
              }
              style={{
                color: window.SCOPE_VALUE.CURRENT == 9 ? "black" : "#007bff",
                cursor:
                  window.SCOPE_VALUE.CURRENT == 9 &&
                    (props.id == "" || props.id == this.state.editedId)
                    ? "default"
                    : "pointer",
              }}
              onClick={() =>
                props.id == "" || props.id == this.state.editedId
                  ? ""
                  : this.handleAnchor(props.id, props.name)
              }
            >
              <div
                className="textarea hospital-name"
                style={{
                  background: "white",
                  height: "2.7em",
                  resize: "none",
                  paddingLeft: "2px",
                  paddingTop: "6px",
                  width: "100%",
                  fontSize: "15px",
                  borderRight: "1px solid rgb(189, 186, 194 )",
                  border:
                    props.id == "" || props.id == this.state.editedId
                      ? "1px solid #D2D4DC"
                      : "none",
                  borderRadius: props.id == "" ? "2px" : "none",
                  cursor:
                    window.SCOPE_VALUE.CURRENT == 9 &&
                      (props.id == "" || props.id == this.state.editedId)
                      ? "default"
                      : "pointer",
                }}
                onInput={(e) => { this.handleNameChange(e, props) }}
                id={"name" + props.id}
                contentEditable={
                  !(props.id == "" ? false : props.id != this.state.editedId)
                    ? "plaintext-only"
                    : false
                }
              >
                {props.name}
              </div>
            </a>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Description</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('description'),
        selector: (row) => (
          <div name="description">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
                overflowY: "scroll"
              }}
              onInput={(e) => { this.handleDescriptionChange(e, row) }}
              id={"description" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.description}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Address</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('address'),
        selector: (row) => (
          <div name="address">
            <div
              className="textarea hospital-address"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => { this.handleAddressChange(e, row) }}
              id={"address" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.address}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Website</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('website'),
        selector: (row) => (
          <div name="website">
            <div
              className="textarea hospital-website"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => { this.handleWebsiteChange(e, row) }}
              id={"website" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.website}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Logo</b>,
        selector: (row) => (
          <div name="logo">
            <img
              id="hospitalLogo"
              src={"data:png;base64," + row.hospitalLogo}
              style={{
                width: "3vw",
                height: "3vw",
                marginLeft: "4vw",
                marginTop: "1vw",
                marginBottom: "1vw",
                display: row.hospitalLogo == null ? "none" : "block",
              }}
            />
            <FileChooser
              id="hospitalLogo"
              style={{
                marginBottom: "1vw",
                display:
                  row.hospitalLogo == null || row.id == this.state.editedId
                    ? "flex"
                    : "none",
              }}
              name="bot-icon-input"
              accept="image/x-png,image/gif,image/jpeg"
              onChange={this.onChangehospitalLogo}
              fileName={row.id == "" || row.id == this.state.editedId ? this.state.hospitalLogoName : ""}
            />
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: "200px",
        selector: (row) => (
          <div id="action">
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
              }}
              disabled={this.state.dataStartedProcessing}
            >
              <img
                className="img-responsive"
                title={
                  row.id == "" || row.id == this.state.editedId
                    ? "Save"
                    : "Edit"
                }
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  row.id == ""
                    ? this.saveImageSrc
                    : row.id != this.state.editedId
                      ? this.editImageSrc
                      : this.saveImageSrc
                }
                onClick={(e) => {
                  this.state.dataStartedProcessing
                    ? this.notifyDataProcessing()
                    : row.id == ""
                      ? this.saveHospitalDetails(row, e)
                      : row.id == this.state.editedId
                        ? this.updateDetailsApi(row, e)
                        : this.makeCelledit(row, e);
                }}
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
                marginLeft: "-6px",
              }}
              title="Delete"
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  row.id === ""
                    ? this.fetchHospitalDetails()
                    : this.openDeletePopUp(row)
                }
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
                marginLeft: "-6px",
              }}
              title="Admin"
              onClick={(e) => {
                this.addAdmin(row, e);
              }}
            >
              <img
                className="img-responsive"
                src={"./assets/images/admin.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
              />
            </button>
          </div>
        ),
        width: 100,
      },
    ];
    return (
      <div style={{ marginRight: "1%" }} id="hospitalTab">
        <div
          style={{
            background: "#F9F9FB",
            display: this.state.showLoader ? "block" : "none",
          }}
        >
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | BackEnd Api </title>
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <div className="row" style={{ marginLeft: "15px" }}>
            <div className="col-sm-4" style={{ marginTop: "2px" }}></div>
          </div>

          <div className="row" style={{ marginLeft: "14px" }}>
            <div className="col-sm-5">
              <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "15px" }}
              >
                Hospital
              </h6>
            </div>
            <div className="col-sm-5" Align="right" style={{ marginLeft: "-15vw" }}>
              <h6 className="taglineTxt"></h6>
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Health System
              </label>
              <select
                value={this.state.selectedHealthSystemId}
                id="healthSystem"
                className="healthSystem"
                onChange={(e) => this.onHealthSystemChange(e)}
                placeholder="Select Health System"
                ref={this.healthSystemDropDownInHospitalRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "50%",
                  marginLeft: "10px",
                }}
              >
                {this.state.healthSystemValue.map((healthSystem) => (
                  <option value={healthSystem.value}>
                    {healthSystem.name}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{ marginLeft: "1vw", marginTop: "1vh" }}>
              <input
                type="text"
                style={{
                  width: "10vw",
                  border: "1px solid #777676",
                  borderRadius: "3px",
                  padding: "10px",
                  height: "0.6vw",
                  paddingRight: "2rem",
                }}
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                placeholder="Search ..."
              />
              {this.state.searchTerm && (
                <span
                  onClick={() => this.clearSearchData()}
                  style={{
                    // position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777676",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    lineHeight: 1,
                    userSelect: "none",
                    marginLeft: "-1vw"
                  }}
                >
                  ×
                </span>
              )}
            </div>
            <div className="col-sm-2 " style={{
              marginTop: "-16px",
              // marginLeft: "-2vw" 
            }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div className="p-2" style={{ marginBottom: "10px" }}>
                  <button
                    className="btn action-button"
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disabled
                        ? this.notifyMsgFieldEmpty
                        : this.addNewHospitalRow
                    }
                  >
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="row"
            style={{ marginLeft: "15px", marginTop: "-10px" }}
          >
            <div className="col-lg-12 ">
              {!this.state.noMatchingData &&
                <div className="card">
                  {this.state.isLoading && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <p>Loading ...</p>
                    </div>
                  )}
                  {!this.state.isLoading && this.state.data.length === 0 && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <p>There are no hospital present.</p>
                    </div>
                  )}
                  {(!this.state.isLoading && this.state.data.length > 0) && (

                    <DataTable
                      columns={columns}
                      data={this.state.data}
                      key={"table-" + this.state.pageNum}
                      onChangePage={this.onPageChange}
                      paginationDefaultPage={this.state.pageNum || 1}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      fixedHeaderScrollHeight="400px"
                      noDataComponent={<this.CustomNoDataComponent />}
                    />)}
                </div>
              }

              <ToastContainer className="Toast-at-center" />
            </div>
          </div>
          <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Hospital;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Hospital.js